export const desktopMaxWidth = '769px'
export const desktopMinWidth = '770px'
